import { render, staticRenderFns } from "./TranUserPackageActivityReminderUpdate.vue?vue&type=template&id=6ff71ba4&scoped=true"
import script from "./TranUserPackageActivityReminderUpdate.vue?vue&type=script&lang=js"
export * from "./TranUserPackageActivityReminderUpdate.vue?vue&type=script&lang=js"
import style0 from "./TranUserPackageActivityReminderUpdate.vue?vue&type=style&index=0&id=6ff71ba4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff71ba4",
  null
  
)

export default component.exports